import { Accordion, Icon } from 'semantic-ui-react';
import PersonPopupWrapper from './PersonPopupWrapper';
import styles from '../Components/styles/InventoryOverviewPopup.module.scss';
import { useTranslation } from 'react-i18next';
type Props = {
  personList: any[];
  isMobile: boolean;
  showPersonalData?: boolean;
};

const AccordionPersonList = ({ personList, isMobile, showPersonalData }: Props) => {
  const firstPerson = personList.length > 0 ? personList[0] : null;
  const name = firstPerson ? firstPerson.name : '';
  const panels = [
    {
      key: 'contacts',
      title: {
        content: (
          <span className={styles.h4}>
            {showPersonalData ? name : name.replace(/[a-z]/g, 'x')}...
          </span>
        ),
      },
      content: {
        content: <PersonPopupWrapper personList={personList} isMobile={isMobile} />,
      },
    },
  ];

  if (personList.length > 0) {
    return <Accordion defaultActiveIndex={-1} panels={panels} styled />;
  } else {
    return <></>;
  }
};

export default AccordionPersonList;
